<template>
  <a v-if="isUrl" :href="url">{{ url }}</a>
  <code v-else>{{ url }}</code>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isAbsoluteUrl } from '@/utils/url';

const props = defineProps({
  url: { type: String, required: true },
});

const isUrl = computed(() => isAbsoluteUrl(props.url));
</script>
